export default __webpack_public_path__ + "static/media/aboutme.a512ab23.png";